export const data = {
  projects: [
    {
      title: "RetailCausal",
      description:
        "Solution for leveraging causal inference tools and technologies for analyzing and optimizing retail operations, such as pricing and inventory. Using Causica, DoWhy, and treatment effect analysis, retailers, business analysts, and decision-makers can quickly and effectively improve profitability and operational efficiency.",
      technologies: [
        "Python",
        "Causica",
        "Dowhy",
        "Refuters",
        "Imputation",
        "Treatment Effect Analysis",
      ],
      github:
        "https://github.com/fellowship/causal-competitor-retail/tree/pranshu-jain",
      img: "https://miro.medium.com/v2/resize:fit:1400/1*526Tq62pGhqOFXblzFpQ-g.jpeg",
    },
    {
      title: "IndLegal",
      description:
        "This project focuses on automating the summarization of legal documents by transitioning from the Indian Penal Code (IPC) to the newly introduced Bhartiya Nayay Sanhita (BNS). The primary objective is to generate concise, legally accurate summaries while adapting references from IPC to BNS, reflecting the latest provisions, punishments, and changes in the legal framework.",
      technologies: ["Python", "BART", "Augmented Summarization", "OCR", "Natural Language Processing"],
      github: "https://github.com/Pranshu321/IndLegal",
      img: "https://github-production-user-asset-6210df.s3.amazonaws.com/86917304/396248238-b7c272c6-91c9-4145-98f2-cd6666eb8962.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAVCODYLSA53PQK4ZA%2F20241216%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20241216T194943Z&X-Amz-Expires=300&X-Amz-Signature=1f0f16549c1002bf577da5acfc3c6130c78a00f137d33e029ffafba4465a7bb3&X-Amz-SignedHeaders=host",
      yt: "https://www.canva.com/design/DAGUHR8A0eo/24F26M30wDuWh5pXeE33Tg/edit?utm_content=DAGUHR8A0eo&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton",
    },
    {
      title: "ResQmate",
      description:
        "ResQmate is a cutting-edge software solution for post-disaster management, providing advanced tools and technologies for tracking and responding to natural disasters, such as floods, hurricanes, and earthquakes",
      technologies: ["Next.Js", "Mongo DB", "Twilio", "Tailwind CSS", "ML"],
      github: "https://github.com/Pranshu321/ResQmate",
      website: "https://resqmate.vercel.app",
      img: "https://user-images.githubusercontent.com/86917304/257323612-c26c490f-fec6-4218-b2b5-7d58ef69cac8.png",
      yt: "https://www.youtube.com/watch?v=mznzv-MpA1Q",
    },
    {
      title: "Shewin",
      description:
        "Web app to modernize women's healthcare by providing personalized feedback, analysis, mood tracking, and period cycle tracking to women who may feel insecure or face social stigma.",
      technologies: ["React", "CSS", "Google Maps", "ML", "MongoDB"],
      github: "https://github.com/Pranshu321/shewin",
      website: "https://shewin.vercel.app",
      img: "https://github-production-user-asset-6210df.s3.amazonaws.com/86917304/257323337-44229ebb-8020-4755-8885-bf27816ca445.png",
      yt: "https://youtu.be/HX6boY6LCmI",
    },
    {
      title: "HealthPilot",
      description:
        "Healthcare system through which user Scheduling Appointments with Doctors and prediciting one's possiblity to have a certain Disease. Here we are using our model's API ",
      technologies: ["React", "SCSS", "ML", "Firebase"],
      github: "https://github.com/Pranshu321/health-pilot",
      website: "https://healthpilot.vercel.app",
      img: "https://user-images.githubusercontent.com/86917304/257323857-547c77d9-9917-4475-9d4b-e343871e3118.png",
      yt: "https://www.youtube.com/watch?v=xerCwrJMf90",
    },
  ],
};
